import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ILocale } from '../models/locale.model';
import { IHttpPagedResponse } from '@irembo-andela/irembogov3-common';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  private baseUrl = environment.apiGatewayBaseUrl + '/admin/v1';

  loadingTranslations: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  translationsLoadedBefore = false;

  constructor(private http: HttpClient) {}

  getSupportedLocales(): Observable<IHttpPagedResponse<ILocale>> {
    return this.http.get<IHttpPagedResponse<ILocale>>(
      `${this.baseUrl}/public/languages?page=0&size=50`
    );
  }
}
